import { useEffect, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import { ConfirmDialog } from "@/components/ConfirmDialog";
import { api, errMsg } from "@/lib/api";

export const studentTokenKey = (code) => `fchem_student_${code}`;

export default function JoinPage() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [first, setFirst] = useState("");
  const [last, setLast] = useState("");
  const [busy, setBusy] = useState(false);
  const [askClaim, setAskClaim] = useState(false);
  const [valid, setValid] = useState(null);

  useEffect(() => {
    api.get(`/play/check/${code}`).then(() => setValid(true)).catch((e) => { toast.error(errMsg(e)); setValid(false); });
  }, [code]);

  if (localStorage.getItem(studentTokenKey(code))) return <Navigate to={`/oyun/${code}`} replace />;
  if (valid === false) return <Navigate to="/" replace />;

  const submit = async (claim = false) => {
    setBusy(true);
    try {
      const { data } = await api.post("/play/join", { code, first_name: first, last_name: last, claim });
      localStorage.setItem(studentTokenKey(code), data.token);
      navigate(`/oyun/${code}`);
    } catch (e) {
      if (e.response?.status === 409) setAskClaim(true);
      else toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-5 py-10">
      <div className="w-full max-w-md space-y-8 fade-in">
      <Logo />
      <div>
        <p className="eyebrow">Oyun kodu <span className="text-[#FACC15] tracking-[0.2em]">{code}</span></p>
        <h1 className="font-display text-5xl font-bold mt-2">Adını <span className="neon-text-green">yaz</span></h1>
      </div>
      <form onSubmit={(e) => { e.preventDefault(); submit(false); }} className="panel p-6 space-y-5" data-testid="join-form">
        <div className="space-y-2">
          <Label htmlFor="first">Ad</Label>
          <Input id="first" value={first} maxLength={30} onChange={(e) => setFirst(e.target.value)} className="h-14 text-xl rounded-2xl bg-[#0B0F16]" data-testid="join-first-name" required />
        </div>
        <div className="space-y-2">
          <Label htmlFor="last">Soyad</Label>
          <Input id="last" value={last} maxLength={30} onChange={(e) => setLast(e.target.value)} className="h-14 text-xl rounded-2xl bg-[#0B0F16]" data-testid="join-last-name" required />
        </div>
        <Button type="submit" disabled={busy || !first.trim() || !last.trim()} className="w-full h-16 text-xl" data-testid="join-submit">Oyuna gir</Button>
      </form>
      <ConfirmDialog open={askClaim} onOpenChange={setAskClaim} title="Bu isimle biri var, sen misin?"
        description="Eğer bu sensen önceki oturumuna geri bağlanırsın. Değilsen Vazgeç'e basıp adını farklı yaz (örn. ikinci adınla)."
        confirmText="Evet, benim" onConfirm={() => { setAskClaim(false); submit(true); }} />
      </div>
    </div>
  );
}
